import React from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../Common/designTokens";
import { headerStyle, modalStyle } from "../OrderEntry/styles";

const DownloadNoLogsPopup = ({ open, onClose, appliedFilters = [] }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="download-no-logs-title"
    >
      <Box
        sx={{
          ...modalStyle,
          width: "560px",
          maxWidth: "92vw",
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ ...headerStyle, flexShrink: 0 }}>
          <Typography
            id="download-no-logs-title"
            variant="h6"
            component="h2"
            sx={{ fontWeight: 700 }}
          >
            Logs Not Available
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ p: 2, overflow: "auto", flex: 1 }}>
          <Typography variant="body2" sx={{ mb: 1.5, color: tokens.colors.fontColour85 }}>
            Logs are not available for the applied filters.
          </Typography>

          {appliedFilters.length > 0 ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {appliedFilters.map((item, index) => (
                <Typography key={`${item.label}-${index}`} variant="body2">
                  <Box component="span" sx={{ fontWeight: 700 }}>
                    {item.label}:
                  </Box>{" "}
                  {item.value}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography variant="body2">Date Range: Past 24 hours (UTC)</Typography>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
            borderTop: `1px solid ${tokens.colors.bodyBorderColor50}`,
            backgroundColor: tokens.colors.defaultGridRowColor,
          }}
        >
          <Button
            onClick={onClose}
            size="small"
            variant="outlined"
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: "8px",
            }}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DownloadNoLogsPopup;
